/**
 * FUSION DES TEXTES DU MODULE AU CHARGEMENT DE SES ROUTES.
 * ============================================================================
 *
 * Patron du module Energy Manager (`energy-manager/utils/i18n.ts`) : les
 * messages du module ne pèsent sur l'application que lorsqu'une de ses routes
 * est ouverte. Ils vivent sous l'espace `alarmesV2.*`, qui n'existe nulle part
 * ailleurs : la fusion ne peut écraser aucun texte existant.
 */
import { i18n } from "@core/plugins/i18n.plugin"
import { MESSAGES_ALARMES_V2 } from "./fr"

/** L'espace des messages du module. */
export const ESPACE_ALARMES_V2 = "alarmesV2"

/** Une fonction de traduction, celle de vue-i18n ou celle d'un test. */
export type Traduire = (
    cle: string,
    valeurs?: Record<string, unknown>
) => string

/** Vrai une fois les messages fusionnés. */
let enregistres = false

/**
 * Fusionne les messages du module dans la langue `fr`. Idempotent : le
 * deuxième appel ne fait rien.
 */
export function enregistrerMessagesAlarmesV2(): void {
    if (enregistres) return
    i18n.global.mergeLocaleMessage("fr", {
        [ESPACE_ALARMES_V2]: MESSAGES_ALARMES_V2,
    })
    enregistres = true
}

/** Les messages à donner à un `createI18n` de test ou de story. */
export function messagesPourUnTest(): {
    alarmesV2: typeof MESSAGES_ALARMES_V2
} {
    return { alarmesV2: MESSAGES_ALARMES_V2 }
}
